exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".single-view-layout .title-bar{height:39px}.single-view-layout .back-link{display:block;float:left;font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:11px;margin-bottom:12px;color:#00aadc;fill:#00aadc}.single-view-layout .back-link:hover{color:#005082;fill:#005082}.single-view-layout .title{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-transform:uppercase;color:#87a6bc;font-size:11px;font-family:Open Sans,Helvetica,Arial,sans-serif}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/single-view-layout.scss
 ** module id = 392
 ** module chunks = 0
 **/